import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=c62b2a52&scoped=true"
import script from "./Extension.vue?vue&type=script&lang=js"
export * from "./Extension.vue?vue&type=script&lang=js"
import style0 from "./Extension.vue?vue&type=style&index=0&id=c62b2a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b2a52",
  null
  
)

export default component.exports